import React from 'react';
import {
  Autocomplete,
  TextField,
  Typography,
  Skeleton,
  Chip,
} from '@mui/material';

const CpdAutocomplete = ({
  options = [],
  value,
  onChange,
  multiple = false,
  label = 'Select',
  placeholder = 'Search and select...',
  size = 'small',
  fullWidth = true,
  required = false,
  disabled = false,
  error = false,
  helperText = '',
  loading = false,
  apiError = null,
  getOptionLabel = (option) => option.name || option.label || option,
  renderOption = null,
  renderTags = null,
  chipColor = 'primary',
  chipVariant = 'outlined',
}) => {
  if (apiError) {
    return (
      <Typography color='error' variant='body2'>
        Error loading {label.toLowerCase()}
      </Typography>
    );
  }

  if (loading) {
    return (
      <Skeleton
        variant='rounded'
        height={size === 'small' ? 40 : 56}
        width='100%'
      />
    );
  }

  const defaultRenderTags = (tagValue, getTagProps) =>
    tagValue.map((option, index) => {
      const { key, ...tagProps } = getTagProps({ index });
      return (
        <Chip
          key={key}
          variant={chipVariant}
          label={getOptionLabel(option)}
          color={chipColor}
          size={size}
          {...tagProps}
        />
      );
    });

  return (
    <Autocomplete
      multiple={multiple}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled}
      options={options}
      value={value}
      onChange={onChange}
      getOptionLabel={getOptionLabel}
      renderOption={
        renderOption
          ? (props, option) => renderOption(props, option)
          : undefined
      }
      renderTags={renderTags || (multiple ? defaultRenderTags : undefined)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          size={size}
          required={required}
          error={error}
          helperText={helperText}
          placeholder={placeholder}
        />
      )}
    />
  );
};

export default CpdAutocomplete;
